<script lang="ts">
    import * as t from '$trans';
    import MenuItem from './MenuItem.svelte';
    import type { createDropdownMenu } from '@melt-ui/svelte';
    import type { NavbarQueryQuery } from '$gql/graphql';
    import { getContainer } from '$components/Context/ContainerContext';

    export let meltMenu: ReturnType<typeof createDropdownMenu>;
    export let navbar: NavbarQueryQuery;

    const { urlHelper, lang } = getContainer();

    $: nbManagedCompanies = navbar.me?.managedCompanies?.length ?? 0;
</script>

{#if navbar.me != null}
    <div class="pt-[24px] pb-[16px]">
        <div class="font-bold mb-[16px] px-[24px]">
            {navbar.me.email}
        </div>

        <ul class="list-unstyled m-0">
            {#if navbar.me.hasAccessAdmin}
                <MenuItem
                    href={urlHelper().adminDashboard()}
                    {meltMenu}
                    icon="tnp tnp-arrow"
                    >{t.navbar.to_admin({}, $lang)}
                </MenuItem>
            {/if}
            <MenuItem
                href={navbar.me.participantProfileLink}
                {meltMenu}
                icon="tnp tnp-user-alt"
                reload={false}
                >{t.navbar.my_profile({}, $lang)}
            </MenuItem>
            <MenuItem
                href={urlHelper().profileEdit()}
                {meltMenu}
                icon="tnp tnp-user-pen-alt"
                >{t.navbar.edit_my_profile({}, $lang)}
            </MenuItem>
            <MenuItem
                href={nbManagedCompanies === 0
                    ? urlHelper().companyCreate()
                    : urlHelper().companyEditSelect()}
                {meltMenu}
                icon="tnp tnp-company-2"
            >
                {t.navbar.edit_or_create_companies({ nb: nbManagedCompanies }, $lang)}
            </MenuItem>
            <MenuItem
                href={urlHelper().inbox()}
                {meltMenu}
                icon="tnp tnp-envelope-alt"
                reload={false}
            >
                {t.navbar.messaging({}, $lang)}
            </MenuItem>
            <MenuItem href={urlHelper().logout()} {meltMenu} icon="tnp tnp-exit">
                {t.navbar.signout({}, $lang)}
            </MenuItem>
        </ul>
    </div>
{/if}
